module.exports = __webpack_public_path__ + "img/logo-light.c4ee25ee.svg";